import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /users/{"{"}userId{"}"}/people/withdm
          </h1>
        </div>
        <b>Find people that had prior direct space history with the viewer (<b><i>Me</i></b>).</b>
        <br/>
        The result of this api can include colleagues as well as people out-side of the viewer's company directory.
        <br />
        <p>                    
          <blockquote>
            <b>Note:</b>
            <p>
              This api will also include all hidden direct conversations.
              <br />
              Read more on how to Hide Direct Spaces {' '}
              <Link to="/tutorials/createanewspace#section11">
                here
              </Link>.                      
            </p>
          </blockquote>
        </p>
        <p>
          Note: Use <em>nextPageUrl</em> and <em>prevPageUrl</em> from the
          response data for query{" "}
          <Link to="/guides/pagination">pagination</Link>.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>userId</td>
                <td>
                  Unique identifier of the user whose colleagues to find. Use
                  keyword <strong>me</strong> for current user.
                </td>
                <td>path</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>search</td>
                <td>
                  Regular expression to filter colleague results. User
                  properties searched: name, username,{" "}

                </td>
                <td>Query</td>
                <td>No</td>
                <td />
              </tr>
              
              <tr>
                <td>size</td>
                <td>The number of responses to return per request</td>
                <td>Query</td>
                <td>No</td>
                <td>10</td>
              </tr>
              <tr>
                <td>page</td>
                <td>The page number of response data</td>
                <td>Query</td>
                <td>No</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/users/me/people/withdm?search=doe
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="javascript">
                    {`
{  
   "data":[  
      {  
         "_id":"fake_id1",
         "type":"user",
         "username":"alexd@abcd.com",
         "displayname":"Alex Doe",
         "picture_url":"fake_photo1.jpg",
         "phone_numbers":[  

         ]
      },
      {  
         "_id":"fake_id2",
         "type":"user",
         "username":"susan.doe@fakedomain.com",
         "displayname":"Susan Doe",
         "picture_url":"fake_photo1.jpg",
         "phone_numbers":[  

         ]
      }
   ],
   "nextPageUrl":"",
   "previousPageUrl":"",
   "total":2,
   "from":0,
   "to":1
}
`}
                  </pre>
      </div>
    </div>
  </Layout>
)
